import React from 'react';

export function TableHeader({ headerGroups, allColumns }) {

    function getClassFor(column) {
        const state = column.canSort ? column.isSorted ? column.isSortedDesc ? 'desc' : 'asc' : 'none' : 'cant'
        const o = 'sort-' + state;
        return column.headerClassName ? column.headerClassName + ' ' + o : o;
    }

    return (
        <thead>
            {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                        // Add the sorting props to control sorting. For this example
                        // we can add them into the header props
                        <th {...column.getHeaderProps(column.getSortByToggleProps())} {...column.getHeaderProps({ className: getClassFor(column) })} >
                            {column.render('Header')}
                        </th>
                    ))}
                </tr>
            ))}
        </thead>
    )
}